import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=2165b61f&scoped=true"
import script from "./ReportHeader.vue?vue&type=script&lang=js"
export * from "./ReportHeader.vue?vue&type=script&lang=js"
import style0 from "./ReportHeader.vue?vue&type=style&index=0&id=2165b61f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2165b61f",
  null
  
)

export default component.exports